export const DEFAULT_AVAILABLE_CONTENT_SLOTS = 5;
